import { Deserializable } from '../interfaces';

export class SeoData implements Deserializable {
  titulo: string;
  descripcion: string;
  urlFotoPerfil: string;
  url: string;
  nombre: string;
  empresa?: string;

  constructor() {
    this.titulo = '';
    this.descripcion = '';
    this.urlFotoPerfil = '';
    this.url = '';
    this.nombre = '';
    this.empresa = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
